import React from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../Atoms/Buttons/CustomButton";
import Seperator from "../../Atoms/Seperator";
import DefineSolution from "./Molecules/DefineSolution";
import DefineSolAgent from "./Molecules/DefineSolAgent";
import DefineSolProvider from "./Molecules/DefineSolProvider";
import DefineSolClassification from "./Molecules/DefineSolClassification";
import { useSolution } from "../../../contexts/SolutionsContext";
import FooterSpacer from "../../Footer/FooterSpacer";
import DefineSolClass from "./Molecules/DefineSolClass";

const SolutionForm = ({ type = "register", solutionId }) => {
  const navigate = useNavigate();

  const {
    clearOngoingSolutionData,
    areAllRequiredFieldsValid,
    resetValidation,
    registerSolution,
    editSolution,
    isLoadingAgents,
    isRegisteringOrEditingSol,
    isLoadingDropdownFields,
    isFetchingSectorsSilently
  } = useSolution();

  const isFormValid = areAllRequiredFieldsValid();

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();

    clearOngoingSolutionData();
    resetValidation();

    navigate("/solutions");
  };

  const handleSubmit = async () => {
    if (type === "register") {
      await registerSolution();
    } else if (type === "edit" && solutionId) {
      await editSolution(solutionId);
    }
  };

  const checkLookupLoadings = () => {
    for (let key in isLoadingDropdownFields) {
      if (isLoadingDropdownFields[key]) {
        return true;
      }
    }
    return false;
  };

  return (
    <article className="register-solution-container">
      <section className="marketplace-sol-form-header">
        <div className="marketplace-sol-form-btns">
          <h4 className="heading-4 fw-bold">
            {`${type === "register" ? "Register" : "Edit"} Solution`}
          </h4>
          <div className="btns d-flex gap-2">
            <CustomButton
              label="Cancel"
              clsNames="mas-secondary-btn-2 mas-btn-med"
              onClickFn={handleCancel}
            />
            <CustomButton
              label={`${type === "register" ? "Register" : "Save"}`}
              clsNames="mas-primary-btn mas-btn-med"
              disabled={
                !isFormValid ||
                isRegisteringOrEditingSol ||
                isLoadingAgents ||
                checkLookupLoadings() ||
                isFetchingSectorsSilently
              }
              onClickFn={handleSubmit}
            />
          </div>
        </div>
        <Seperator
          clsNames={
            "mas-horizontal-seperator-100 marketplace-horizontal-seperator-wd"
          }
          styles={{
            backgroundColor: "var(--db-secondary-gray-seven)",
            padding: "0 48px",
          }}
        />
      </section>

      <section className="register-solution-form">
        <div className="def-sol">
          <DefineSolution sno={1} />
        </div>
        <div className="def-sol-agent">
          <DefineSolAgent sno={2} />
        </div>
        <div className="def-sol-provider">
          <DefineSolProvider sno={3} />
        </div>
        <div className="def-sol-classification">
          {/* <DefineSolClassification sno={4} /> */}
          <DefineSolClass sno={5} type={type} />
        </div>
      </section>

      <FooterSpacer
        styles={{ height: "calc(var(--db-footer-height) + 75px)" }}
      />
    </article>
  );
};

export default SolutionForm;
